export const siteInfo = {
  name: '白丝萝莉',
  tagline: '探索洛丽塔时尚的无限魅力',
  description: '白丝萝莉是国内领先的洛丽塔时尚文化平台，致力于为洛丽塔爱好者提供最新最全的时尚资讯、穿搭指南、品牌推荐和活动信息。我们汇聚了一群热爱洛丽塔文化的创作者，以专业的视角和真挚的热爱，为每一位洛丽塔爱好者提供有价值的内容。',
  founded: '2019',
  members: '50万+',
  articles: '500+',
  brands: '100+',
  contact: {
    email: 'hello@baisiluoli.com',
    wechat: '白丝萝莉官方',
    weibo: '@白丝萝莉',
    xiaohongshu: '@白丝萝莉',
    address: '上海市静安区洛丽塔文化交流中心',
  },
  reputation: [
    {
      id: '1',
      name: '小樱',
      role: '资深洛丽塔爱好者',
      content: '白丝萝莉是我每天必看的洛丽塔资讯平台，从穿搭技巧到品牌推荐，内容专业又贴心。通过这里我认识了很多志同道合的朋友，真的非常感谢！',
      rating: 5,
    },
    {
      id: '2',
      name: '琉璃',
      role: '洛丽塔品牌主理人',
      content: '作为洛丽塔品牌的主理人，我非常欣赏白丝萝莉的专业性。平台内容质量高，用户群体精准，是我们品牌与用户沟通的重要桥梁。',
      rating: 5,
    },
    {
      id: '3',
      name: '桃子',
      role: '洛丽塔入门新手',
      content: '刚入坑洛丽塔的时候什么都不会，是白丝萝莉的新手攻略帮我一步步构建了自己的第一个洛丽塔衣橱。特别感谢平台的用心内容！',
      rating: 5,
    },
    {
      id: '4',
      name: '芷若',
      role: '洛丽塔茶会组织者',
      content: '作为经常组织洛丽塔茶会的发起人，白丝萝莉的活动资讯板块是我获取灵感和推广活动的重要渠道。平台的茶会指南写得非常专业！',
      rating: 5,
    },
    {
      id: '5',
      name: '雪莉',
      role: '洛丽塔时尚博主',
      content: '在白丝萝莉发表文章让我结识了更多热爱洛丽塔的朋友。平台对原创内容的支持和尊重，让我们这些创作者感到非常温暖和被认可。',
      rating: 5,
    },
    {
      id: '6',
      name: '铃兰',
      role: '五年洛丽塔爱好者',
      content: '关注白丝萝莉已经三年了，见证了平台一路走来的成长。无论是内容质量还是社区氛围，白丝萝莉都是我心中最好的洛丽塔文化交流平台。',
      rating: 5,
    },
  ],
  timeline: [
    { year: '2019', event: '白丝萝莉正式成立，开始分享洛丽塔时尚内容' },
    { year: '2020', event: '社区成员突破10万，举办首届线上洛丽塔穿搭大赛' },
    { year: '2021', event: '与20+洛丽塔品牌建立合作关系，推出品牌推荐专栏' },
    { year: '2022', event: '举办线下洛丽塔茶会系列活动，覆盖全国10座城市' },
    { year: '2023', event: '社区成员突破30万，成为国内最具影响力的洛丽塔平台之一' },
    { year: '2024', event: '推出中华风洛丽塔专题，推动中国传统文化与洛丽塔时尚的融合' },
    { year: '2025', event: '成员突破50万，品牌合作超过100家，持续引领洛丽塔时尚文化潮流' },
  ],
};

export const faqItems = [
  {
    question: '什么是洛丽塔时尚风格？',
    answer: '洛丽塔时尚（Lolita Fashion）起源于日本，是一种以维多利亚时代和洛可可时期服装为灵感来源的时尚风格。它以蓬松的及膝裙、精致的蕾丝装饰、可爱的蝴蝶结为标志性特征，主要分为甜美洛丽塔、古典洛丽塔和哥特洛丽塔三大流派。洛丽塔时尚追求的是优雅、精致和如同洋娃娃般甜美的形象。',
  },
  {
    question: '新手如何开始入坑洛丽塔时尚？',
    answer: '对于洛丽塔新人，建议从一条百搭的基础款JSK（跳线裙）开始，搭配白色蕾丝衬衫、裙撑、白色及膝袜和玛丽珍鞋，即可完成一套入门级的洛丽塔造型。建议先确定自己喜欢的风格流派（甜美、古典或哥特），再针对性地选择单品。白丝萝莉平台有丰富的新手攻略文章，可以帮助你快速入门。',
  },
  {
    question: '洛丽塔裙子一般多少钱？',
    answer: '洛丽塔裙子的价格范围很广，国牌基础款JSK通常在300-800元之间，设计更精致的在800-2000元不等；日系品牌如Baby、AP等通常在2000-5000元甚至更高。建议新手先从性价比高的国牌入手，逐步建立自己的审美和收藏。',
  },
  {
    question: '白丝在洛丽塔造型中有什么作用？',
    answer: '白丝（白色丝袜或白色及膝袜）是洛丽塔造型中不可或缺的经典单品。它不仅是基础穿搭单品，更是决定整体风格的关键配饰。白丝能在视觉上拉长腿部线条，衬托出洛丽塔裙装的甜美气质，与各种颜色的裙装搭配都十分协调，是洛丽塔衣橱中利用率最高的单品之一。',
  },
  {
    question: '洛丽塔茶会是什么？如何参加？',
    answer: '洛丽塔茶会是洛丽塔爱好者聚集交流的社交活动，通常包括下午茶品鉴、服装展示、摄影交流等环节。参加茶会需要穿着正式的洛丽塔裙装，遵守茶会着装规范和社交礼仪。可以关注白丝萝莉的活动资讯板块或各大洛丽塔品牌的官方账号获取茶会信息。',
  },
  {
    question: '中华风洛丽塔和传统汉服有什么区别？',
    answer: '中华风洛丽塔是在洛丽塔蓬裙廓形基础上融入中国传统元素（如盘扣、刺绣、云肩）的风格，本质仍属于洛丽塔时尚；而汉服是严格还原中国古代服饰形制的传统服装。两者的廓形结构、穿着方式和配饰搭配都有明显不同，中华风洛丽塔更偏向于文化融合的创意设计。',
  },
];